import React, { useEffect, useState } from 'react'
import Table from '../../Components/Table'
import '../../Assets/Css/Employees.scss'
import { useNavigate } from 'react-router-dom'
import RoleWiseFeatureWrapper, { checkFeatureAccess } from '../../Lib/RoleWiseFeatureWrapper'
import ModulesList from '../../Assets/ModulesLiist'
import FeaturesList from '../../Assets/FeaturesList'
import { connect } from 'react-redux'
import { getUsers } from '../../Services/Users/action'
import { deleteRecord } from '../../Services/Delete/action'
import { Spinner } from 'react-bootstrap'
import { exportData } from '../../Lib/exportData'
import { toast } from 'react-toastify';
import Select from 'react-select';
import moment from 'moment';
import { customStyle } from '../../Components/Style';
import "../../Assets/Css/Holiday.scss";
import DatePicker from 'react-datepicker';
import { getDesignations } from '../../Services/Designation/action'
import Skeleton from 'react-loading-skeleton'

const Employees = (props) => {
  let footer = true;
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [totalSelectedIds, setTotalSelectedIds] = useState([]);
  const [exportLoading, setExportLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedDesignation, setSelectedDesignation] = useState(null);
  const [selectedJoiningDate, setSelectedJoiningDate] = useState([]);
  const [selectedEmployeeType, setSelectedEmployeeType] = useState(null);

  const header = [
    { field: 'checkbox' },
    { field: 'Code' },
    { field: 'Employee' },
    { field: 'Mobile' },
    { field: 'Personal Email' },
    { field: 'Department' },
    { field: 'Designation' },
    { field: 'Action' }
  ];

  const fetchData = async () => {
    try {
      const options = {
        module: 'employees',
        id: props?.user?.role?.name === "employee" ? props?.user?.id : null
      };
      await props.getUsersList(options);
      await props.getDesignationList();
    } catch (error) {
      console.error("Error fetching Users (Employees):", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [])

  useEffect(() => {
    const processedData = props?.users
      ?.filter((item) => props?.user?.role?.name == 'employee' ? (item?.role?.name === 'employee' && item?.id == props?.user?.id) : (item?.role))
      ?.map((employee) => {
        return {
          checkbox: {
            value: employee?.id,
            type: "checkbox",
          },
          Code: {
            value: employee?.employee_code,
            isNavigate: true,
            type: 'text'
          },
          Employee: {
            value: employee?.name,
            value2: employee?.email,
            src: employee?.profile_pic?.data || "",
            isNavigate: true,
            type: 'client',
          },
          Action: {
            value: '/employees/edit',
            value2: `/employees/view/profile/${employee?.id}`,
            value3: employee?.id,
            type: 'action'
          },
          Mobile: {
            value: employee?.mobile,
            isNavigate: true,
            type: 'text'
          },
          Department: {
            value: employee?.department?.name,
            isNavigate: true,
            type: 'text'
          },
          Designation: {
            value: employee?.designation?.name,
            isNavigate: true,
            type: 'text'
          },
          'Personal Email': {
            value: employee?.personal_email || '-',
            type: 'text'
          },
          allData: {
            ...employee
          }
        }
      });

    setData(processedData || []);
  }, [props])


  useEffect(() => {
    let filtered = [...data];

      if (searchTerm) {
      filtered = filtered.filter(item =>
        item.allData?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.allData?.personal_email?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.allData?.email?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    if (selectedDesignation) {
      filtered = filtered.filter(item =>
        item.allData?.designation?.name === selectedDesignation.value
      );
    }

    if (selectedJoiningDate && selectedJoiningDate.some(date => date !== null)) {
      const [startDate, endDate] = selectedJoiningDate;

      filtered = filtered.filter(item => {
        const joiningDate = moment(item.allData?.joining_date);
        if (startDate && endDate) {
          return joiningDate.isBetween(moment(startDate), moment(endDate), 'day', '[]');
        } else if (startDate) {
          return joiningDate.isSameOrAfter(moment(startDate), 'day');
        } else if (endDate) {
          return joiningDate.isSameOrBefore(moment(endDate), 'day');
        }
        return true;
      });
    }

    if (selectedEmployeeType) {
      filtered = filtered.filter(item =>
        item.allData?.employee_type === selectedEmployeeType.value
      );
    }


    setFilteredData(filtered);
  }, [data, searchTerm, selectedDesignation, selectedJoiningDate, selectedEmployeeType]);

  const nameOptions = [...new Set(data.map(item => item.allData?.name))]
    .filter(name => name)
    .map(name => ({ value: name, label: name }));

  const designationOptions = [...new Set(props?.designations?.map(item => item.name))]
    .filter(designation => designation)
    .map(designation => ({ value: designation, label: designation }));

  const employeeTypeOptions = [...new Set(data.map(item => item.allData?.employee_type))]
    .filter(type => type)
    .map(type => ({ value: type, label: type }));


  const joiningDateOptions = [...new Set(data.map(item => {
    if (item.allData?.joining_date) {
      const date = moment(item.allData.joining_date);
      return date.format('YYYY-MM-DD');
    }
    return null;
  }))]
    .filter(date => date)
    .map(date => {
      const momentDate = moment(date);
      return {
        value: date,
        label: momentDate.format('DD MMM YYYY')
      };
    })
    .sort((a, b) => moment(a.value).diff(moment(b.value)));

  const canEdit = checkFeatureAccess({
    modules: props?.modules,
    features: props?.features,
    user: props?.user,
    ModuleName: ModulesList.Employees,
    Featur_Name: FeaturesList.Update,
  });

  const canDelete = checkFeatureAccess({
    modules: props?.modules,
    features: props?.features,
    user: props?.user,
    ModuleName: ModulesList.Employees,
    Featur_Name: FeaturesList.Delete,
  });

  const canView = checkFeatureAccess({
    modules: props?.modules,
    features: props?.features,
    user: props?.user,
    ModuleName: ModulesList.Employees,
    Featur_Name: FeaturesList.View,
  });

  const handleXlsxDownload = (Ids) => {
    const excludedFields = ['checkbox', 'Action'];
    const columns = header
      .filter(col => !excludedFields.includes(col.field))
      .map(col => ({
        label: col.field,
        key: col.field
      }));

    const selectedData = filteredData
      .filter(item => Ids.includes(item.allData?.id))
      .map(row => {
        const newRow = {};

        columns.forEach(({ label, key }) => {
          const cell = row[key];

          if (!cell) {
            newRow[label] = '';
          } else if (Array.isArray(cell.value)) {
            newRow[label] = cell.value.join(', ');
          } else {
            newRow[label] = cell.value ?? '';
          }
        });

        return newRow;
      });

    exportData({
      data: selectedData,
      columns,
      fileName: 'Employee_Report',
      format: 'xlsx',
    });
    setExportLoading(false)
    setTotalSelectedIds([])
  };

  const handleClick = async (totalSelectedIds, type) => {
    let ids = totalSelectedIds.map((id) => parseFloat(id));
    try {
      if (type === 'export') {
        setExportLoading(true);
        handleXlsxDownload(ids);
        toast.success('Exported Successfully');
      }
    } catch (error) {
      console.error(error);
    } finally {
      await fetchData();
    }
  };

  const handleChange = (event) => {
    const { type, checked, id, ids } = event;

    if (type === "select-all") {
      setTotalSelectedIds(checked ? [...ids] : []);
    } else if (type === "select-one") {
      if (checked) {
        setTotalSelectedIds(prev => [...prev, id]);
      } else {
        setTotalSelectedIds(prev => prev.filter(selectedId => selectedId !== id));
      }
    }
  };


  const handleClear = () => {
    setSearchTerm('');
    setSelectedDesignation(null);
    setSelectedJoiningDate([]);
    setSelectedEmployeeType(null);
  };

  return (
    <div className='employee-main'>
      <div className="page-title">
        {
          props.loading ? (
            <Skeleton className='rounded-2' width={200} height={40} />
          ) : (
            <h4>Employees List</h4>
          )
        }
        <div className="edit-btn">
          {
            props.loading ? (<Skeleton className='badge rounded-pill' width={100} height={40} />) : (
              <RoleWiseFeatureWrapper
                modules={props?.modules}
                features={props?.features}
                user={props?.user}
                ModuleName={ModulesList.Employees}
                Featur_Name={FeaturesList.Create}>
                <button className="custom-btn" onClick={() => navigate('/employees/add')}>Add</button>
              </RoleWiseFeatureWrapper>
            )
          }

          {
            props.loading ? <Skeleton className='badge rounded-pill' width={100} height={40} /> : (
              <button
                className="export-btn"
                id="exportBtn"
                disabled={totalSelectedIds.length <= 0 || exportLoading}
                onClick={(e) => {
                  e.preventDefault();
                  handleClick(totalSelectedIds, 'export');
                }}
              >
                Export
              </button>
            )
          }
        </div>
      </div>

      {location.pathname === "/employees" && (
        <div className='holiday-filters'>
          <div className='row'>
            <div className="col-lg-3">
              {
                props.loading ? (
                  <Skeleton className="rounded-2" width="100%" height={40} />
                ) : (
                  <div className="input-group">
                    <input
                      type="text"
                      className="input-css"
                      placeholder='Search Name...'
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>
                )
              }
            </div>

            <div className="col-lg-3">
              {
                props.loading ? (
                  <Skeleton className='rounded-2' width={200} height={40} />
                ) : (
                  <Select
                    options={designationOptions}
                    styles={{
                      ...customStyle,
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 2,
                      }),
                    }}
                    value={selectedDesignation}
                    onChange={(val) => setSelectedDesignation(val)}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: "#5757fe",
                        primary: "#5757fe",
                      },
                    })}
                    placeholder="Designation"
                    isClearable
                  />
                )
              }
            </div>

            <div className="col-lg-3">
              {
                props.loading ? (
                  <Skeleton className='rounded-2' width={200} height={40} />
                ) : (
                  <DatePicker
                    selectsRange
                    selected={selectedJoiningDate[0]}
                    startDate={selectedJoiningDate[0]}
                    endDate={selectedJoiningDate[selectedJoiningDate.length - 1]}
                    onChange={(date) => setSelectedJoiningDate(date)}
                    dateFormat="dd-MM-yyyy"
                    placeholderText="Joining Date"
                    className="form-control"
                    style={{
                      ...customStyle,
                      minHeight: '40px',
                      borderColor: '#ddd',
                      borderRadius: '4px',
                      padding: '8px 12px',
                      fontSize: '14px',
                      width: '100%'
                    }}
                    isClearable
                  />)
              }
            </div>

            <div className="col-lg-3">
              {
                props.loading ? (
                  <Skeleton className='rounded-2' width={200} height={40} />
                ) : (
                  <Select
                    options={employeeTypeOptions}
                    styles={{
                      ...customStyle,
                      menu: (provided) => ({
                        ...provided,
                        zIndex: 2,
                      }),
                    }}
                    value={selectedEmployeeType}
                    onChange={(val) => setSelectedEmployeeType(val)}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: "#5757fe",
                        primary: "#5757fe",
                      },
                    })}
                    placeholder="Employee Type"
                    isClearable
                  />
                )
              }
            </div>

            <div className='col-lg-1'>
              {(searchTerm || selectedDesignation || (selectedJoiningDate && selectedJoiningDate.some(date => date !== null)) || selectedEmployeeType) ? (
                <div className=''>
                  <button className='export-btn' onClick={handleClear}>Clear</button>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      )}
      {
        props.loading ? (
          <Skeleton className='rounded-2' count={10} width="100%" height={30} />
        ) : (
          <Table
            loading={props?.loading}
            header={header}
            footer={footer}
            data={filteredData}
            count={filteredData?.length}
            records={filteredData?.length}
            showIsEdit={canEdit}
            showIsDelete={canDelete}
            showIsView={canView}
            deleteRecord={props?.deleteRecord}
            totalSelectedIds={totalSelectedIds}
            handleChange={handleChange}
          />
        )
      }
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    loading: state.userReducer.loading,
    modules: state.authenticationReducer.modules,
    features: state.authenticationReducer.features,
    users: state.userReducer.users,
    user: state.authenticationReducer.user,
    designations: state.designationReducer.designation
  };
};

export const mapDispatchToProps = (dispatch) => ({
  getFeatureList: () => dispatch(getFeatures()),
  getModuleList: () => dispatch(getModules()),
  getUsersList: (options) => dispatch(getUsers(options)),
  getDesignationList: () => dispatch(getDesignations()),
  deleteRecord: async (id, inputValue) => {
    await dispatch(deleteRecord(id, inputValue));
    await dispatch(getUsers({ module: 'employees', id: null, }));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(Employees);